/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-prototype-builtins */
import { NaturalFormWrapper, ReturnToHomeButtonWrapper } from '@app.styled';
import { CodingConstants } from '@constants';
import { broadcastCashOutResponse, fetchWidgetRefreshAsync, setOfferTypeSelected } from '@store/actions/widgets.actions';
import { selectLoan } from '@store/selectors/widgets.selectors';
import { Identifier } from '@types';
import { auth, config } from '../config';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    NaturalDisaster,
    NaturalDisasterProps,
    NaturalDisasterConstants,
    type EventType,
    CompletedEventDetails,
    ReturnToHome
} from 'shared-ui-components';
import { useCallback, useEffect, useState } from 'react';
import { logUserEvent, logApiEvent } from '@analytics/amplifyLogging';

const NaturalDisasterACP = ({
    borrowerImpacted = '',
    loanNumber,
    updateLoanType,
    getOption
}: {
    borrowerImpacted?: string;
    loanNumber: string;
    updateLoanType: any;
    getOption: any;
}) => {
    const dispatch = useDispatch();
    const loanList: Identifier[] = useSelector(selectLoan);
    const token = auth.getOkta().getAccessToken();
    const [isForbearancePage, setiIsForbearancePage] = useState(false);
    const loanOptions: Identifier[] = useSelector(selectLoan);

    const apiEvents = useCallback((event: EventType) => {
        logApiEvent({
            apiName: event.apiName,
            action: event.action,
            correlationId: event.correlationId,
            timestamp: event.timestamp,
            loanNumber: event.loanNumber,
            description: event.description,
            type: 'Natural Disaster ACP widget'
        });
    }, []);

    const userEvents = useCallback((event: EventType) => {
        logUserEvent({
            type: 'Natural Disaster ACP widget',
            action: event.action,
            loanNumber: loanNumber,
            description: event.description
        });
    }, []);

    const [NDProps, setNDProps] = useState<NaturalDisasterProps | null>();

    useEffect(() => {
        if (borrowerImpacted === 'Y') {
            setNDProps({
                accessToken: token,
                logApiEvent: userEvents,
                logUserEvent: apiEvents,
                config: {
                    metadata: {
                        stepNumber: 1,
                        steps: 2,
                        type: 'NaturalDisaster'
                    },
                    1: {
                        id: 1,
                        screen: 'RadioCardGroup',
                        metadata: {
                            id: 'DisasterPropertyImpacted',
                            title: 'Has your home been affected?',
                            navigation: {
                                current: 1,
                                next: 2,
                                back: 1
                            },
                            valueKey: 'propertyImpactDetermination',
                            metadata: [
                                {
                                    id: 'DisasterHomeYesImpactClicked',
                                    icon: 'YesIcon',
                                    label: 'Yes',
                                    value: 'Y',
                                    textProps: { color: '#0A4A8D' }
                                },
                                {
                                    id: 'DisasterHomeNoImpactClicked',
                                    icon: 'NoIcon',
                                    label: 'No',
                                    value: 'N',
                                    textProps: { color: '#0A4A8D' }
                                }
                            ]
                        }
                    },
                    2: {
                        id: 2,
                        screen: 'RadioCardGroup',
                        metadata: {
                            id: 'DisasterWorkplaceImpacted',
                            title: 'Has your workplace been affected?',
                            navigation: {
                                current: 2,
                                next: 3,
                                back: 1
                            },
                            valueKey: 'workplaceImpactDetermination',
                            metadata: [
                                {
                                    id: 'DisasterWorkYesImpactClicked',
                                    icon: 'YesIcon',
                                    label: 'Yes',
                                    value: 'Y',
                                    textProps: { color: '#0A4A8D' }
                                },
                                {
                                    id: 'DisasterWorkNoImpactClicked',
                                    icon: 'NoIcon',
                                    label: 'No',
                                    value: 'N',
                                    textProps: { color: '#0A4A8D' }
                                }
                            ]
                        }
                    },
                    3: {
                        id: 3,
                        screen: 'RequestForbearance',
                        metadata: {
                            id: 'requestForbearance',
                            navigation: {
                                current: 3,
                                next: 3,
                                back: 2
                            },
                            valueKey: 'requestForbearance',
                            metadata: NaturalDisasterConstants.FORBEARANCE_CARDS_CONTENT
                        }
                    }
                },
                onComplete: (event: CompletedEventDetails) => {
                    setiIsForbearancePage(true);
                    if (event.toastType === 'DEEPLINK') {
                        dispatch(fetchWidgetRefreshAsync.request('?refresh=true'));
                    } else {
                        updateLoanType(CodingConstants.servicingLoanType);
                        dispatch(broadcastCashOutResponse(event));
                    }
                    if (event.toastType === 'DEEPLINK') {
                        dispatch(fetchWidgetRefreshAsync.request('?refresh=true'));
                    } else {
                        updateLoanType(CodingConstants.servicingLoanType);
                        dispatch(broadcastCashOutResponse(event));
                    }
                },
                forbearanceApiParams: {
                    baseUrl: config.env('natDisasterAWSUrl') + `/${loanNumber}/natural-disaster/`,
                    baseAWSUrl: config.env('natDisasterAWSUrl') + `/${loanNumber}/natural-disaster/`,
                    xApiKey: config.env('xApiKey'),
                    accountNumber: loanNumber,
                    isCreateCit: loanList[0]?.forbearance_check,
                    redirectUrl: loanList[0]?.forbearance_redirect_url
                },
                metadata: {
                    initialState: {
                        0: { borrowerImpacted: borrowerImpacted },
                        1: { propertyImpactDetermination: '' },
                        2: { workplaceImpactDetermination: '' },
                        3: { determinationMethod: 'BORROWER NOTIFICATION' }
                    },
                    request: {
                        borrowerImpacted: borrowerImpacted,
                        propertyImpactDetermination: '',
                        workplaceImpactDetermination: '',
                        determinationMethod: 'BORROWER NOTIFICATION'
                    }
                },
                requestedBy: 'ACP'
            });
        } else if (borrowerImpacted === 'N') {
            setNDProps({
                accessToken: token,
                logApiEvent: userEvents,
                logUserEvent: apiEvents,
                config: {
                    metadata: {
                        stepNumber: 1,
                        steps: 1,
                        type: 'NaturalDisaster'
                    },
                    1: {
                        id: 1,
                        screen: 'RequestForbearance',
                        metadata: {
                            id: 'requestForbearance',
                            navigation: {
                                current: 1,
                                next: 1,
                                back: 1
                            },
                            valueKey: 'requestForbearance',
                            metadata: NaturalDisasterConstants.FORBEARANCE_CARDS_CONTENT
                        }
                    }
                },
                onComplete: (event: CompletedEventDetails) => {
                    setiIsForbearancePage(true);
                    if (event.toastType === 'DEEPLINK') {
                        dispatch(fetchWidgetRefreshAsync.request('?refresh=true'));
                    } else {
                        updateLoanType(CodingConstants.servicingLoanType);
                        dispatch(broadcastCashOutResponse(event));
                    }
                },
                forbearanceApiParams: {
                    baseUrl: config.env('natDisasterAWSUrl') + `/${loanNumber}/natural-disaster/`,
                    baseAWSUrl: config.env('natDisasterAWSUrl') + `/${loanNumber}/natural-disaster/`,
                    xApiKey: config.env('xApiKey'),
                    accountNumber: loanNumber,
                    isCreateCit: loanList[0]?.forbearance_check,
                    redirectUrl: loanList[0]?.forbearance_redirect_url
                },
                metadata: {
                    initialState: {
                        0: { borrowerImpacted: borrowerImpacted },
                        1: { propertyImpactDetermination: 'N' },
                        2: { workplaceImpactDetermination: 'N' },
                        3: { determinationMethod: 'BORROWER NOTIFICATION' }
                    },
                    request: {
                        borrowerImpacted: borrowerImpacted,
                        propertyImpactDetermination: 'N',
                        workplaceImpactDetermination: 'N',
                        determinationMethod: 'BORROWER NOTIFICATION'
                    }
                },
                requestedBy: 'ACP'
            });
        } else {
            setNDProps({
                accessToken: token,
                logApiEvent: userEvents,
                logUserEvent: apiEvents,
                config: {
                    metadata: {
                        stepNumber: 1,
                        steps: 1,
                        type: 'NaturalDisaster'
                    },
                    1: {
                        id: 1,
                        screen: 'RequestForbearance',
                        metadata: {
                            id: 'requestForbearance',
                            navigation: {
                                current: 1,
                                next: 1,
                                back: 1
                            },
                            valueKey: 'requestForbearance',
                            metadata: NaturalDisasterConstants.FORBEARANCE_CARDS_CONTENT
                        }
                    }
                },
                onComplete: (event: CompletedEventDetails) => {
                    setiIsForbearancePage(true);
                    if (event.toastType === 'DEEPLINK') {
                        dispatch(fetchWidgetRefreshAsync.request('?refresh=true'));
                    } else {
                        updateLoanType(CodingConstants.servicingLoanType);
                        dispatch(broadcastCashOutResponse(event));
                    }
                },
                forbearanceApiParams: {
                    baseUrl: config.env('natDisasterAWSUrl') + `/${loanNumber}/natural-disaster/`,
                    baseAWSUrl: config.env('natDisasterAWSUrl') + `/${loanNumber}/natural-disaster/`,
                    xApiKey: config.env('xApiKey'),
                    accountNumber: loanNumber,
                    isCreateCit: loanList[0]?.forbearance_check,
                    redirectUrl: loanList[0]?.forbearance_redirect_url
                },
                metadata: {
                    initialState: {
                        0: { borrowerImpacted: borrowerImpacted },
                        1: { propertyImpactDetermination: '' },
                        2: { workplaceImpactDetermination: '' },
                        3: { determinationMethod: 'BORROWER NOTIFICATION' }
                    },
                    request: {
                        borrowerImpacted: borrowerImpacted,
                        propertyImpactDetermination: '',
                        workplaceImpactDetermination: '',
                        determinationMethod: 'BORROWER NOTIFICATION'
                    }
                },
                requestedBy: 'ACP'
            });
        }
    }, []);

    const onClickHome = () => {
        dispatch(setOfferTypeSelected(undefined));
        const options = loanOptions?.filter(option => option.type == CodingConstants.servicingLoanType);
        if (options && options.length > 0) getOption(options[0]);
    };
    return (
        <>
            {isForbearancePage ? (
                <ReturnToHomeButtonWrapper>
                    <ReturnToHome onPress={onClickHome} />
                </ReturnToHomeButtonWrapper>
            ) : null}

            <NaturalFormWrapper>{NDProps && <NaturalDisaster {...NDProps} />}</NaturalFormWrapper>
        </>
    );
};

export default React.memo(NaturalDisasterACP);
